<template>
  <div class="step step3">
    <div class="form">
      <div class="form-title">{{ labels.extraInformation }}</div>
      <div class="form-fields extra-info">
        <div class="row col-1">
          <div class="col">
            <DropList
              mandatory
              :label="labels.distributor"
              :data="distributors"
              labels="name"
              values="name"
              v-model="state.distributor"
              @change="checkValue('distributor')"
              :invalid="invalidFields.distributor"
              :placeholder="labels.dropdownPlaceholder"
            ></DropList>
          </div>
        </div>
        <div class="row col-1">
          <div class="col">
            <TextBox
              :label="labels.otherDistributor"
              mandatory 
              v-model="state.otherDistributor"
              @change="checkValue('otherDistributor')"
              v-if="state.distributor.indexOf(labels.other) !== -1"
              :invalid="invalidFields.otherDistributor"
            ></TextBox>
          </div>
        </div>
        <div class="row col-1">
          <div class="col">
            <NoteBox
              :label="labels.feedback"
              v-model="state.feedback"
              rows="10"
            ></NoteBox>
          </div>
        </div>
        <div class="row col-1">
          <div class="col">
            <p class="disclaimer1">{{labels.disclaimer1}}</p>
            <p class="disclaimer2">{{labels.disclaimer2}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DropList, NoteBox, TextBox } from "clariant-vue3-forms";
import { Labels, State, Utils, DataLayer } from "../services.js";

export default {
  name: "ExtraInformation",
  components: {
    DropList,
    NoteBox,
    TextBox
  },
  data() {
    return {
      state: State,
      labels: Labels,
      distributors: [],
      invalidFields: {
        distributor: false,
        otherDistributor: false
      }
    };
  },
  mounted() {
    DataLayer.getDistributors().then(data => {
          this.distributors = data;
      }).catch (err => {
          let msg = err.Message || err;
          Utils.showStatusMessage(msg, "red");
      });
  },
  methods: {
    validateStep() {
      let ret = true;

      if (!this.checkValue("distributor")) ret = false;

      if (State.distributor.indexOf(Labels.other) !== -1) {
        if (!this.checkValue("otherDistributor")) ret = false;
      }

      if (!ret) {
        Utils.showStatusMessage(Labels.invalidFields, "yellow");
      }
      return ret;
    },
    checkValue(field) {
      if (!field) return false;
      if (State[field]) {
        this.invalidFields[field] = false;
      } else this.invalidFields[field] = true;

      return !this.invalidFields[field];
    }
  }
};
</script>

<style scoped>
.extra-info {
  margin-top: 40px;
}

.disclaimer2 {
  font-weight: 700;
}
</style>
